import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Table } from 'rsuite'
import { toast } from '../../CommonComponents/ToastComponent/toast';
import { checkIsPhoneNumberValid, checkIsEmailValid, addBusinessDays } from '../../../services/helper';
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { Loader } from 'rsuite';
import moment from 'moment'
import { getListDetails, getSuppliersQaInfo, getEnablementResultsTable } from '../../../redux/actions/vendor';
import ThreeStateToggleButton from '../../CommonComponents/ThreeStateToggleButton';
import { updateCompanyInfo } from '../../../redux/actions/partner';
import { parsePhoneNumber } from 'awesome-phonenumber';

const { Column, HeaderCell, Cell, ColumnGroup } = Table

export const TableCell = ({ rowData, dataKey, onClick, totalSpend = 0, ...props }) => {
    let fullCompletionDate;
    if (dataKey === 'estimatedCompletionDate') {
        var addDays = 10;
        const importedDate = moment(rowData?.['dateSubmitted']);
        let completionDate = addBusinessDays(importedDate, addDays)
        let year = completionDate.year()
        let month = completionDate.month() < 10 ? '0' + (completionDate.month() + 1) : (completionDate.month() + 1)
        let date = completionDate.date() < 10 ? '0' + completionDate.date() : completionDate.date()
        fullCompletionDate = month + '-' + date + '-' + year
    }

    if (dataKey === 'dateSubmitted') {
        const importedDate = rowData?.['dateSubmitted'] ? moment(rowData?.['dateSubmitted']).format('MM/DD/YYYY') : '';
        rowData[dataKey] = importedDate
    }

    return (
        <Cell {...props} className="table-link list-table-cell text-black" id={rowData.id}>
            {(dataKey === 'totalApSpend') ? totalSpend : dataKey === 'estimatedCompletionDate' ? fullCompletionDate : rowData[dataKey]}
        </Cell>
    )
}
const GeneralInformation = ({ generalInfoData, listTableColumns, totalApSpend }) => {
    const infoColumns = [
        { name: 'companyName', label: 'Company Name' },
        { name: 'primaryContact', label: 'Primary Contact' },
        { name: 'contactEmail', label: 'Contact Email' },
        { name: 'contactPhone', label: 'Contact Phone' },
        { name: 'nameUse', label: 'Name Use' }
    ]

    const dispatch = useDispatch()
    const [companyInfo, setCompanyInfo] = useState({})
    const [oldCompanyInfo, setOldCompanyInfo] = useState({})
    const [isPhoneValid, setIsPhoneValid] = useState('')
    const [isValidatingPhone, setIsValidatingPhone] = useState(false)
    const [isEmailValid, setIsEmailValid] = useState('')
    const [isValidatingEmail, setIsValidatingEmail] = useState(false)
    const [countryCode, setCountryCode] = useState('')
    const [isLoadingListDetails, setIsLoadingListDetails] = useState(false)
    const [saveLoader, setSaveLoader] = useState(false)
    const phoneInputRefname = useRef(null);
    const [listDetailsTableData, setListDetailsTableData] = useState({
        totalSuppliers: 0,
        matchedSuppliers: 0,
        suppliersSubmittedToSequence: 0,
        suppliersThroughSequence: 0,
        supplierSuccessQa: 0,
        supplierUnsuccessQa: 0,
        supplierNoResponseQaCount: 0,
        supplierPendingQa: 0,
        percentageComplete: 0,
    });
    const [enablResultsTableData, setEnablResultsTableData] = useState([
        {
            rowHeading: "Total",
            data: {
                "Total Suppliers": 0,
                "Accepts Card No Conditions": 0,
                "Accepts Card w/ Conditions": 0,
                "Does Not Accept Card": 0,
                "Needs Data": 0,
                "No Response": 0,
                "In-Process": 0,
                "Removed": 0,
            }
        },
        {
            rowHeading: "Matched",
            data: {
                "Total Suppliers": 0,
                "Accepts Card No Conditions": 0,
                "Accepts Card w/ Conditions": 0,
                "Does Not Accept Card": 0,
                "Needs Data": 0,
                "No Response": 0,
                "In-Process": 0,
                "Removed": 0,
            }
        },
        {
            rowHeading: "Campaigned",
            data: {
                "Total Suppliers": 0,
                "Accepts Card No Conditions": 0,
                "Accepts Card w/ Conditions": 0,
                "Does Not Accept Card": 0,
                "Needs Data": 0,
                "No Response": 0,
                "In-Process": 0,
                "Removed": 0,
            }
        }
    ]);

    const updateMultipleRows = (updates) => {
        const updatedData = enablResultsTableData.map(item => {
            if (updates[item.rowHeading]) {
                return {
                    ...item,
                    data: { ...updates[item.rowHeading] }
                };
            }
            return item;
        });

        setEnablResultsTableData(updatedData);
    };

    useEffect(() => {
        if (!generalInfoData || generalInfoData.length === 0) {
            return
        }
        setCompanyInfo(generalInfoData)
        setOldCompanyInfo(generalInfoData)

        setIsLoadingListDetails(true)
        dispatch(getListDetails(generalInfoData?.id)).then(async (res) => {
            await dispatch(getSuppliersQaInfo(generalInfoData?.id)).then(data => {
                setListDetailsTableData((prevData) => {
                    return {
                        ...prevData,
                        totalSuppliers: res?.totalListSuppliers || 0,
                        matchedSuppliers: res?.totalMatchedListSuppliers || 0,
                        suppliersSubmittedToSequence: data.supplierSubmittedSequence || 0,
                        suppliersThroughSequence: data.suppliersThroughSequence || 0,
                        supplierSuccessQa: data.supplierSuccessQa || 0,
                        supplierUnsuccessQa: data.supplierUnsuccessQa || 0,
                        supplierNoResponseQaCount: data.supplierNoResponseQaCount || 0,
                        supplierPendingQa: data.supplierPendingQa || 0,
                        percentageComplete: data.suppliersThroughSequence > 0 ? ((data.suppliersThroughSequence / res.totalListSuppliers) * 100).toFixed(2) + " %" : "0 %"
                    };
                });

                dispatch(getEnablementResultsTable(generalInfoData?.id)).then(data => {
                    updateMultipleRows({
                        "Total": {
                            "Total Suppliers": res?.totalListSuppliers || 0,
                        },
                        "Matched": {
                            "Total Suppliers": res?.totalMatchedListSuppliers || 0,
                        },
                        "Campaigned": {
                            "Total Suppliers": data.supplierSubmittedSequence || 0,
                        }
                    })
                })


            });



            setIsLoadingListDetails(false)
        }).catch(() => {
            setIsLoadingListDetails(false)
        })
    }, [generalInfoData])

    const handleChangeInfo = (colName, value) => {
        let tmpValue = value
        if (colName === 'contactEmail') {
            if (!tmpValue) {
                setIsEmailValid(true)
            } else {
                setIsEmailValid('')
            }
        } else if (colName === 'phoneExtension') {
            if (/^\d{20}$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,20}/gi) ? value.match(/^\d{1,20}/gi)[0] : ''
            }
        }

        const updatedCompanyInfo = { ...companyInfo, [colName]: tmpValue }
        setCompanyInfo(updatedCompanyInfo)
    }

    const handlePhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var phoneNewValue = phoneValue ? '+' + phoneValue : phoneValue
        const phone = parsePhoneNumber(phoneNewValue);
        const isValid = phone?.valid || false
        if (!isValid) {
            setIsPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode?.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            setIsValidatingPhone(true)
            phoneValue = phoneValue?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            setIsPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsPhoneValid(true)
        }
        if (isUseEffect) {
            setCompanyInfo({ ...companyInfo, 'contactPhone': phoneValidationResult?.phoneNumber })
        }
    }

    const handlePhoneInputChange = (value, country, e, formattedValue) => {
        var phoneValue = formattedValue?.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '')?.replace(/[^\w\s]|[\s]/gi, '')
        var countrycode = country.dialCode + ' '
        if (phoneValue !== '') {
            phoneValue = countrycode + phoneValue
            setIsPhoneValid('')
        } else {
            phoneValue = country.dialCode
            setIsPhoneValid(true)
        }
        if (e.target === null) {
            handlePhoneNumberFocusOut(e, country, formattedValue)
        }
        setCountryCode(country.dialCode)
        setCompanyInfo({
            ...companyInfo,
            'contactPhone': phoneValue === '' ? '' : phoneValue,
        })
    }

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handleEmailFocusOut = async (emailValue) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch)
            setIsEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
        } else {
            setIsEmailValid(true)
        }
    }

    const onSaveCompanyDetails = async () => {
        if (isValidatingPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating phone number...!',
            })
            return
        }
        if (isValidatingEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating email...!',
            })
            return
        }

        if (isEmailValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Contact Email!'
            })
            return
        }
        if (isPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Contact Phone Number!'
            })
            return
        }

        setSaveLoader(true)

        await dispatch(updateCompanyInfo(companyInfo)).then(res => {
            setSaveLoader(false)
            toast.show({
                title: 'Success',
                description: 'Company details updated'
            })
        }).catch((err) => {
            setSaveLoader(false)
        })
    }


    const onClearCompanyDetails = () => {
        handleEmailFocusOut(oldCompanyInfo?.email)
        validateEmailAndPhone(oldCompanyInfo?.contactPhone)
        setCompanyInfo(oldCompanyInfo)
    }


    const validateEmailAndPhone = useCallback(async (phoneValue) => {
        if (phoneValue !== '') {
            setIsValidatingPhone(true)
            let phone = phoneValue?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phone, phoneValue, dispatch)
            setIsPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsPhoneValid(false)
            setIsValidatingPhone(false)
        }

    })

    useEffect(() => {
        if (Object.keys(companyInfo).length !== 0) {
            validateEmailAndPhone(companyInfo?.phone)
        }
    }, [])

    const tableHeaders = [
        { label: "Total Suppliers", name: "totalSuppliers" },
        { label: "Matched Suppliers", name: "matchedSuppliers" },
        { label: "Suppliers Submitted to Sequence", name: "suppliersSubmittedToSequence" },
        { label: "Suppliers Through Sequence", name: "suppliersThroughSequence" },
        { label: "Suppliers Pending QA", name: "supplierPendingQa" },
        { label: "% Complete", name: "percentageComplete" },
    ];

    const tableData = [
        listDetailsTableData
    ];

    const DynamicTable = ({ headers, data }) => (
        <Table rowHeight={100} virtualized={true} cellBordered height={130} data={data}>
            {headers.map((header, index) => {
                if (header.name === "suppliersThroughSequence") {
                    return (
                        <Column name={index} align="center" flexGrow={1} resizable>
                            <HeaderCell className="fw-bold text-black">{header.label}</HeaderCell>
                            <Cell
                                className="text-black text-center"
                                dataKey={header.name}
                            >
                                {rowData => (
                                    <>
                                        <div>{rowData[header.name]}</div>
                                        <div>
                                            <hr />
                                            <table style={{ width: '100%', border: 'none', marginTop: '10px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ fontSize: '11px' }}>Successful</th>
                                                        <th style={{ fontSize: '11px' }}>Unsuccessful</th>
                                                        <th style={{ fontSize: '11px' }}>No Response</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{listDetailsTableData.supplierSuccessQa}</td>
                                                        <td>{listDetailsTableData.supplierUnsuccessQa}</td>
                                                        <td>{listDetailsTableData.supplierNoResponseQaCount}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </Cell>
                        </Column>
                    );
                }

                // Render normal columns
                return (
                    <Column name={index} flexGrow={1} resizable>
                        <HeaderCell className='fw-bold text-black text-center'>{header.label}</HeaderCell>
                        <Cell className='text-black text-center' dataKey={header.name} />
                    </Column>
                );
            })}
        </Table>
    );

    const enablResultsTableableHeaders = [
        { label: "", name: "rowHeading" },
        { label: "Total Suppliers", name: "Total Suppliers" },
        { label: "Accepts Card No Conditions", name: "Accepts Card No Conditions" },
        { label: "Accepts Card w/ Conditions", name: "Accepts Card w/ Conditions" },
        { label: "Does Not Accept Card", name: "Does Not Accept Card" },
        { label: "Needs Data", name: "Needs Data" },
        { label: "No Response", name: "No Response" },
        { label: "In-Process", name: "In-Process" },
        { label: "Removed", name: "Removed" },
    ];

    const EnablementResultsTable = ({ headers, data }) => (
        <Table virtualized={true} cellBordered data={data}>
            {headers.map((header, index) => {
                if (header.name === "rowHeading") {
                    return (
                        <Column key={index} name={header.name} flexGrow={1} resizable>
                            <HeaderCell className="fw-bold text-black text-center">{header.label}</HeaderCell>
                            <Cell className="text-black text-center" dataKey={header.name}>
                                {rowData => (
                                    <div>{rowData.rowHeading}</div>
                                )}
                            </Cell>
                        </Column>
                    );
                }

                if (header.subHeaders && header.subHeaders.length > 0) {
                    return (
                        <Column key={index} name={header.name} align="center" flexGrow={1} resizable>
                            <HeaderCell className="fw-bold text-black">{header.label}</HeaderCell>
                            <Cell className="text-black text-center" dataKey={header.name}>
                                {rowData => (
                                    <>
                                        <div>{rowData.data[header.name]}</div>
                                        <div>
                                            <hr />
                                            <table style={{ width: '100%', border: 'none', marginTop: '10px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ fontSize: '11px' }}>{header.subHeaders[0]}</th>
                                                        <th style={{ fontSize: '11px' }}>{header.subHeaders[1]}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{rowData.data.Matched}</td>
                                                        <td>{rowData.data.Campaigned}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </Cell>
                        </Column>
                    );
                }
                return (
                    <Column key={index} name={header.name} flexGrow={1} resizable>
                        <HeaderCell className="fw-bold text-black text-center">{header.label}</HeaderCell>
                        <Cell className="text-black text-center" dataKey={header.name}>
                            {rowData => rowData.data[header.name]}
                        </Cell>
                    </Column>
                );
            })}
        </Table>
    );



    return (
        <div className={`general-information mt-4`}>
            <div className='d-flex row'>
                {
                    infoColumns.map((col, ind) => (
                        <div key={ind} className='item col-12 col-xl-6 d-flex gap-5 align-items-center mb-4'>
                            <h4 className="label mb-0 w-50 flex-grow-1">{col.label}:</h4>
                            {col.name === 'contactPhone' ?
                                <div className="w-100 flex align-center flex-grow-1 gap-2">
                                    <div className='d-flex border rounded phone-input-ext-container w-100 flex-column'>
                                        <ReactPhoneInput
                                            className='phone-input-parent'
                                            country={'us'}
                                            value={companyInfo[col.name]}
                                            onChange={handlePhoneInputChange}
                                            onBlur={(event, country) => { handlePhoneNumberFocusOut(event, country, companyInfo[col.name]) }}
                                            countryCodeEditable={false}
                                            preferredCountries={['us']}
                                            onKeyDown={(e) => handleKeyDown(e, phoneInputRefname)}
                                            ref={phoneInputRefname}
                                            buttonClass='border-0 border-end'
                                            inputProps={{
                                                className: 'form-control border-0'
                                            }}
                                        />
                                    </div>
                                    {isValidatingPhone && (<Loader />)}
                                    {companyInfo[col.name] && !isValidatingPhone && isPhoneValid !== '' &&
                                        (isPhoneValid ?
                                            <BsCheckSquare color="#067911" size={26} />
                                            :
                                            <BsXSquare color="#f75a52" size={26} />
                                        )
                                    }
                                </div>
                                :
                                col.name === 'contactEmail' ?
                                    <div className="w-100 d-flex gap-2 align-items-center">
                                        <input
                                            className={`w-100 search-input`}
                                            type="text"
                                            value={companyInfo[col.name] || ''}
                                            onChange={e => handleChangeInfo(col.name, e.target.value)}
                                            onBlur={() => { handleEmailFocusOut(companyInfo[col.name]) }}
                                        />
                                        {isValidatingEmail && (<Loader />)}
                                        {companyInfo[col.name] && !isValidatingEmail && isEmailValid !== '' &&
                                            (isEmailValid ?
                                                <BsCheckSquare color="#067911" size={26} />
                                                :
                                                <BsXSquare color="#f75a52" size={26} />
                                            )
                                        }
                                    </div>
                                    :
                                    col.name === 'nameUse' ?
                                        <div className="w-100 d-flex gap-2 align-items-center">
                                            <ThreeStateToggleButton
                                                checked={companyInfo[col.name]}
                                                onChange={(checked) => { handleChangeInfo(col.name, checked) }}
                                            />
                                        </div>
                                        :
                                        <div className="w-100">
                                            <input
                                                className='search-input flex-grow-1'
                                                value={companyInfo[col.name] || ''}
                                                placeholder={col.name?.replace(/(?=[A-Z])/, ' ').toLowerCase()}
                                                onChange={(e) => handleChangeInfo(col.name, e.target.value)}
                                            />
                                        </div>
                            }
                        </div>
                    ))
                }
            </div>
            <div className='d-flex justify-content-end column-gap-3'>
                <button className='pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-green text-white' onClick={onSaveCompanyDetails}>{saveLoader ? <Loader style={{ zIndex: 1 }} size='sm' /> : 'Save'}</button>
                <button className='pt-3 pb-3 p-5 h-75 rounded h4 mb-0 bg-gray text-white' onClick={onClearCompanyDetails}>Cancel</button>
            </div>
            <div className='list-table mt-5'>
                <h4 className='mb-0 fw-bold'>List Details</h4>
                <div className={`position-relative mt-4 border border-2 rounded${isLoadingListDetails ? ' loading' : ''}`}>
                    {isLoadingListDetails && <Loader style={{ zIndex: 1 }} center={true} size='md' />}
                    <DynamicTable headers={tableHeaders} data={tableData} />
                </div>
            </div>
            {/* <div className='list-table mt-5'>
                <h4 className='mb-0 fw-bold'>Enablement Results</h4>
                <div className={`position-relative mt-4 border border-2 rounded${isLoadingListDetails ? ' loading' : ''}`}>
                    {isLoadingListDetails && <Loader style={{ zIndex: 1 }} center={true} size='md' />}
                    <EnablementResultsTable headers={enablResultsTableableHeaders} data={enablResultsTableData} />
                </div>
            </div> */}
        </div>
    )
}

export default GeneralInformation